import { mutationCreateOrderReturn } from "@/graphql/schemas/order/mutations/mutationCreateOrderReturn"
import { queryCustomerOrdersByNumber } from "@/graphql/schemas/order/queries/queryCustomerOrdersByNumber"
import { queryOrderReturnsByOrderNumbers } from "@/graphql/schemas/order/queries/queryOrderReturnsByOrderNumbers"

import { mutationCancelDocument } from "./mutations/mutationCancelDocument"
import { mutationCreateOrderFromCustomerCart } from "./mutations/mutationCreateOrderFromCustomerCart"
import { mutationUpdatePicklist } from "./mutations/mutationUpdatePicklist"
import { mutationUpdateReservation } from "./mutations/mutationUpdateReservation"
import { typeOrder } from "./order"
import { queryAdmOrders } from "./queries/queryAdmOrders"
import { queryCustomerOrder } from "./queries/queryCustomerOrder"
import { queryCustomerOrderByNumber } from "./queries/queryCustomerOrderByNumber"
import { queryCustomerOrders } from "./queries/queryCustomerOrders"
import { queryFindPrevNextOrderForAdm } from "./queries/queryFindPrevNextOrderForAdm"
import { queryFindPrevNextOrderForCustomer } from "./queries/queryFindPrevNextOrderForCustomer"
import { queryIdmOrders } from "./queries/queryIdmOrders"
import { queryOrderReturn } from "./queries/queryOrderReturn"
import { queryOrdersPaletteStats } from "./queries/queryOrdersPaletteStats"

const orderSchema = {
  types: [typeOrder],
  resolvers: {
    Query: {
      // TODO this is not in use. Use case and permissions are unclear.
      // ...queryOrder,
      // ...queryOrders,
      ...queryCustomerOrders,
      ...queryCustomerOrder,
      ...queryAdmOrders,
      ...queryCustomerOrderByNumber,
      ...queryCustomerOrdersByNumber,
      ...queryFindPrevNextOrderForAdm,
      ...queryFindPrevNextOrderForCustomer,
      ...queryOrderReturnsByOrderNumbers,
      ...queryOrderReturn,
      ...queryIdmOrders,
      ...queryOrdersPaletteStats,
    },
    Mutation: {
      ...mutationCreateOrderFromCustomerCart,
      ...mutationUpdateReservation,
      ...mutationCreateOrderReturn,
      ...mutationUpdatePicklist,
      ...mutationCancelDocument,
    },
  },
}

export default orderSchema
